import { Card } from '@/components/Card'
import { Pill } from '@/components/Pill'
import { More } from '@/components/More'
import { IconContainer } from '@/components/IconContainer'
import { DropdownMenu } from '@/components/DropdownMenu'
import { FaviconFetcher } from '@/components/FaviconFetcher'
import { CopyToClipboard } from '@/components/CopyToClipboard'
import { ArrowIcon } from '@/icons'
import { Link } from '@/types'

import s from './LinkCard.module.css'

type Props = {
  link: Link & { sharedAccess?: 'read' | 'write' }
  onEdit: () => void
  onShare: () => void
  onDelete: () => void
  allowActions?: boolean
}

export const LinkCard = ({
  link,
  onEdit,
  onShare,
  onDelete,
  allowActions = true,
}: Props) => {
  const isMultiLink = link.destinations.length > 1

  return (
    <Card className={s.link} key={link.id}>
      <div className={s.linkContent}>
        <IconContainer size="lg">
          <FaviconFetcher url={link.destinations[0]} />
        </IconContainer>

        <div className={s.linkText}>
          <div className={s.slug}>
            <a
              className={s.title}
              href={`https://g.to/${link.slug}`}
              target="_blank"
              rel="noopener"
            >
              g.to/{link.slug}
            </a>
            <CopyToClipboard text={link.slug} />
          </div>
          <p className={s.destination}>
            <span className={s.arrow}>{ArrowIcon}</span>
            <span
              className={s.destinationUrl}
              title={`${link.destinations.join('\n\n')}`}
            >
              <span className={s.destinationUrlText}>
                {link.destinations[0].replace(/^https?:\/\/(www\.)?|\/$/gi, '')}{' '}
              </span>
              {isMultiLink ? (
                <span className={s.more}>{`+${
                  link.destinations.length - 1
                } more`}</span>
              ) : (
                ''
              )}
            </span>
          </p>
        </div>

        <div className={s.pill}>
          <Pill type={link.sharedAccess ? 'shared' : link.type} />
        </div>
        {allowActions && (
          <div className={s.actions}>
            <DropdownMenu>
              <DropdownMenu.Trigger disabled={link.sharedAccess === 'read'}>
                <More />
              </DropdownMenu.Trigger>
              <DropdownMenu.Content>
                <DropdownMenu.Item onClick={onEdit}>Edit</DropdownMenu.Item>
                <DropdownMenu.Item onClick={onShare}>Share</DropdownMenu.Item>
                <DropdownMenu.Item onClick={onDelete} destructive>
                  Delete
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu>
          </div>
        )}
      </div>
    </Card>
  )
}
